import firebase from 'firebase/app';
import 'firebase/auth';
import { client } from '../http';

export async function publishToTypeshare({
  isScheduled,
  username,
  shareToTwitter,
  shareToLinkedIn,
  shareToMedium,
  isThread,
  threadMeta,
  pubTime,
  collectionID,
  postID,
  subtitle,
  altText,
  customSlug,
}) {
  try {
    const authToken = await firebase.auth().currentUser.getIdToken(true);
    const { data } = await client.post('/api/publishing/typeshare', {
      authToken: authToken,
      username,
      isScheduled,
      shareToTwitter,
      shareToLinkedIn,
      shareToMedium,
      isThread,
      threadMeta,
      pubTime,
      collectionID,
      postID,
      subtitle,
      altText,
      customSlug,
    });
    return data.success;
  } catch (error) {
    console.log(error);
    return false;
  }
}
